// extracted by mini-css-extract-plugin
export var button = "_kt-0";
export var donut = "_kt-1";
export var donutFill = "_kt-3";
export var donutTrack = "_kt-2";